import type { ExtendedObservation } from '@seen/core/models/observation'
import type { JSX } from 'react'
import { ObservationNodeFieldForm } from '#src/components/rich-text-editor/ObservationNode/ObservationNodeFieldForm.tsx'
import { ObservationRichTextEditor } from '#src/components/rich-text-editor/ObservationNode/ObservationRichTextEditor.tsx'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'

export function ObservationNoteFieldForm({
  observation,
  className,
  singleLine = false,
  autofocus = false,
  clinician = false,
}: {
  observation: ExtendedObservation
  className?: string
  singleLine?: boolean
  autofocus?: boolean
  // The clinician note of an observation whose first note is its value (a
  // vital), rather than that first note.
  clinician?: boolean
}): JSX.Element {
  const practitioner = useCurrentPractitioner()
  return (
    <ObservationNodeFieldForm
      instance={observation}
      valueFn={(o) => (clinician ? o.clinicianNote : o.noteFirstText)}
      patchFn={(o, v) => {
        if (clinician) {
          o.setClinicianNote(v ?? undefined, practitioner.reference)
        } else {
          o.setNoteFirst(v ?? undefined, practitioner.reference)
        }
        o.performerPractitioner = practitioner.reference
      }}
      debounceTyping
      render={({ field }) => (
        <ObservationRichTextEditor
          placeholder="Notes…"
          singleLine={singleLine}
          autofocus={autofocus ? 'end' : false}
          {...field}
        />
      )}
      className={className}
    />
  )
}
